// 회원기본 정보 등록

import { useMutation } from "@tanstack/react-query";
import { joinDefaultApi } from "components/api/member";
import { apifield } from "components/utils/comm";
import { useTranslation } from "react-i18next";
import useAlertStore from "store/alert";
import { useBaseJoinParamContext } from "./context";

export const useJoinBaseCreateMutate = () => {
  const { t } = useTranslation();
  const onSetAlert = useAlertStore((state) => state.onSetAlert);
  const { onReset } = useBaseJoinParamContext();

  return useMutation({
    mutationFn: joinDefaultApi,
    onSuccess: (res) => {
      if (res) {
        const {
          status: { code, message },
          data,
        } = res;
        if (code === 0) {
          // 회원기본정보 등록 완료
          onSetAlert({
            isOpen: true,
            inner: t("alt_auth_eml_done"),
            onSetConfirm: () => {
              onReset();
            },
          });
        }

        if (code === -1) {
          apifield(message);
        }
      }
    },
  });
};
